import toggle from '../helpers/class-toggle';
import { isDesktop } from '../helpers/exportFunc';

export default () => {
	const sections = document.querySelectorAll('.features');

	sections.forEach(function(section) {
		const labels = section.querySelectorAll('.features__label');

		labels.forEach(function(label, index) {
			label.addEventListener('click', function() {
				setSlideState(index, section, 'active');
			});

			label.addEventListener('mouseenter', function() {
				if(isDesktop()) {
					setSlideState(index, section, 'hover');
					section.classList.add('features--hover');
				}
			});

			label.addEventListener('mouseleave', function() {
				if(isDesktop()) {
					setSlideState(index, section, 'hover', true);
					section.classList.remove('features--hover');
				}
			});

		});
	});

	function setSlideState(index, section, state, remove = false) {
		if (!section) return;
		const labels = section.querySelectorAll('.features__label');
		const images = section.querySelectorAll('.features__img');
		const textSlides = section.querySelectorAll('.features__text-slide');
		const stateClass = 'is-'+state;

		if (remove) {
			labels[index].classList.remove(stateClass);
			images[index].classList.remove(stateClass);
			textSlides[index].classList.remove(stateClass);
		} else {
			toggle(labels, labels[index], stateClass);
			toggle(images, images[index], stateClass);
			toggle(textSlides, textSlides[index], stateClass);
		}
		
	}
}